import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { AmplitudeTracker } from './AmplitudeTracker';
import { GoogleAnalytics } from './GoogleAnalytics';
import { Box } from '@mui/material';

export const Layout: React.FC = () => {
  return (
    <AmplitudeTracker>
      <GoogleAnalytics />
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        minHeight: '100vh',
        width: '100%',
        backgroundColor: 'background.default'
      }}>
        <ScrollToTop />
        <Header />
        <Box 
          component="main" 
          sx={{ 
            flexGrow: 1, 
            width: '100%',
            backgroundColor: 'background.default',
            minHeight: '100%'
          }}
        >
          <Outlet />
        </Box>
        <Footer />
      </Box>
    </AmplitudeTracker>
  );
}; 